import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios/index';

import {
    Card, Button, Table, Icon, message, Modal,
} from 'antd';

import { ADD_PATIENT_DETAILS } from '../../ActionTypes/ActionTypes';
import AddressBox from './AddressBox';
import AddressModalForm from './AddressModalForm';
import './Users.css';


const { Column } = Table;
const { confirm } = Modal;

class User extends Component {
    state = {
        data: '',
        loading: false,
        error: '',
        addresses: [],
        visible: false,
        selectedIndex: '',
        selectedData: {},
        confirmLoading: false,
    };


    componentDidMount = () => {
        const { match } = this.props;
        const { id } = match.params;
        this.setState({ loading: true });
        axios({
            method: 'get',
            url: `/users/${id}.json`,
            headers: { Authorization: sessionStorage.getItem('jwtToken') },
        })
            .then((response) => {
                this.setState({
                    data: response.data,
                    addresses: response.data.addresses,
                    loading: false,
                });
            }).catch((error) => {
                alert(`${error}: ${error.code}`);
            });
    };

    saveFormAddressPatient = (formRef) => {
        this.formRefAddress = formRef;
    };

    onEditClick = (index) => {
        const { addresses } = this.state;
        const { form } = this.formRefAddress.props;
        form.resetFields();

        this.setState({
            selectedData: addresses[index],
            selectedIndex: index,
        }, () => {
            this.setState({
                visible: true,
            });
        });
    }

    addAddressClick = () => {
        const { form } = this.formRefAddress.props;
        form.resetFields();

        this.setState({
            selectedData: {},
            selectedIndex: '',
            visible: true,
        });
    }

    createEditNewAddress = () => {
        const {
            selectedIndex, data, selectedData, addresses,
        } = this.state;
        const { form } = this.formRefAddress.props;
        console.log(selectedData.id);

        form.validateFields((err, values) => {
            if (!err) {
                console.log(values);
                // if selected index == '' then post otherwise, put call

                this.setState({
                    confirmLoading: true,
                });

                values.user_id = data.id;

                if (selectedIndex === '') {
                    axios({
                        method: 'post',
                        url: '/addresses.json',
                        headers: { Authorization: sessionStorage.getItem('jwtToken') },
                        data: { address: values },
                    })
                        .then(() => {
                            form.resetFields();
                            this.cancelAddingEditingAddress();
                            // add the address to list
                            const updatedAddresses = [...addresses];
                            updatedAddresses.push(values);

                            this.setState({
                                addresses: updatedAddresses,
                                confirmLoading: false,
                            }, () => message.success('Address added successfully'));
                        })
                        .catch((error) => {
                            this.setState({
                                confirmLoading: false,
                            }, () => message.error('Something went wrong'));
                            console.log(error);
                        });
                } else {
                    axios({
                        method: 'put',
                        url: `/addresses/${selectedData.id}.json`,
                        headers: { Authorization: sessionStorage.getItem('jwtToken') },
                        data: { address: values },
                    })
                        .then(() => {
                            form.resetFields();
                            this.cancelAddingEditingAddress();
                            // replace the address in the list & put the id back
                            values.id = selectedData.id;
                            const index = addresses.indexOf(selectedData);

                            const updatedAddresses = [...addresses];
                            updatedAddresses.splice(index, 1, values);

                            this.setState({
                                addresses: updatedAddresses,
                                confirmLoading: false,
                            }, () => message.success('Address updated successfully'));
                        })
                        .catch((error) => {
                            this.setState({
                                confirmLoading: false,
                            }, () => message.error('Something went wrong'));
                            console.log(error);
                        });
                }
            }
        });
    }

    cancelAddingEditingAddress = () => {
        const { form } = this.formRefAddress.props;
        form.resetFields();

        this.setState({
            selectedData: {},
            selectedIndex: '',
            confirmLoading: false,
            visible: false,
        });
    }

    showDeleteConfirm = (id, index) => {
        const { addresses } = this.state;

        confirm({
            title: 'Are you sure?',
            content: 'This address will be deleted from the database & can not be recovered.',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk: () => {
                this.setState({
                    loading: true,
                });
                axios({
                    method: 'delete',
                    url: `/addresses/${id}.json`,
                    headers: { Authorization: sessionStorage.getItem('jwtToken') },
                })
                    .then(() => {
                        // remove from the list
                        const updatedAddresses = [...addresses];
                        updatedAddresses.splice(index, 1);

                        this.setState({
                            addresses: updatedAddresses,
                            loading: false,
                        }, () => message.success('Address deleted successfully'));
                    })
                    .catch((error) => {
                        this.setState({
                            loading: false,
                        }, () => message.error('Something went wrong'));

                        console.log(error);
                    });
            },
            onCancel: () => {
                console.log('Cancel');
            },
        });
    }

    render() {
        const { history } = this.props;
        const {
            data, loading, addresses, visible, selectedData, confirmLoading,
        } = this.state;

        return (
            <div>
                <Card
                    title="User Details"
                    extra={(
                        <Button
                            type="primary"
                            onClick={() => history.goBack()}
                        >
                            <Icon type="left" />
                            Go back
                        </Button>
                    )}
                    loading={loading}
                    bordered
                    style={{
                        width: '90%', minHeight: '500px', margin: 'auto', textAlign: 'center', boxShadow: ' 3px 3px 5px 6px #ccc',
                    }}
                >
                    <div>
                        <p>User ID - {data === undefined ? null : data.id}</p>
                        <p>User Name - {data === undefined ? null : `${data.first_name} ${data.last_name}`}</p>
                    </div>

                    <div style={{ marginTop: '40px', marginBottom: '40px' }}>
                        <h2>
                            Addresses
                        </h2>
                        <hr width="200px" />

                        <Button type="primary" onClick={this.addAddressClick}> Add address </Button>
                    </div>

                    <div style={{
                        overflowX: 'scroll',
                        overflowY: 'hidden',
                        whiteSpace: 'nowrap',
                        display: 'flex',
                        flexDirection: 'row',
                    }}
                    >
                        {
                            addresses.map((address, index) => (
                                <AddressBox
                                    key={index}
                                    address={address}
                                    index={index}
                                    onEditClick={this.onEditClick}
                                    onDeleteClick={this.showDeleteConfirm}
                                />
                            ))
                        }

                    </div>

                    <br />


                    <div>
                        <h2>All orders</h2>
                        <hr width="100px" />

                        <Table
                            dataSource={data.array}
                            pagination={false}
                            rowKey="id"
                        >
                            <Column
                                title="Order ID"
                                dataIndex="id"
                            />

                            <Column
                                title="Start Date"
                                dataIndex="start_date"
                            />

                            <Column
                                title="End Date"
                                dataIndex="end_date"
                            />

                            <Column
                                title="Refill Cycle"
                                dataIndex="refill_cycle"
                            />

                        </Table>
                    </div>

                </Card>

                <AddressModalForm
                    visible={visible}
                    data={selectedData}
                    wrappedComponentRef={this.saveFormAddressPatient}
                    onCreate={this.createEditNewAddress}
                    onCancel={this.cancelAddingEditingAddress}
                    confirmLoading={confirmLoading}
                />
            </div>
        );
    }
}


const mapStateToProps = state => ({
    token: state.AppState.token,
    loggedIn: state.AppState.loggedIn,
});

const mapDispatchToProps = dispatch => ({
    setOrderValuesInStore: data => dispatch({ type: ADD_PATIENT_DETAILS, data }),
});


export default connect(mapStateToProps, mapDispatchToProps)(User);



// WEBPACK FOOTER //
// ./src/component/Users/Users.js